import React, { useEffect, useState } from "react";
import {
  PieChart,
  BarChart2,
  Calendar,
  Activity,
  CheckCircle,
  AlertCircle,
} from "lucide-react";
import StatCard from "./StatCard";
import { useTheme } from '@/App';

// Stats configuration with light and dark mode colors
const getStats = (isDark) => [
  {
    label: "Total Products",
    value: "",
    icon: <BarChart2 color={isDark ? "#60a5fa" : "#3b82f6"} size={24} />,
    bgColor: isDark ? "#1e3a5f" : "#dbeafe",
    iconColor: isDark ? "#60a5fa" : "#3b82f6",
  },
  {
    label: "Total MBMRs",
    value: "",
    icon: <PieChart color={isDark ? "#c084fc" : "#a855f7"} size={24} />,
    bgColor: isDark ? "#4c1d95" : "#f3e8ff",
    iconColor: isDark ? "#c084fc" : "#a855f7",
  },
  {
    label: "Scheduled Batches",
    value: "",
    icon: <Calendar color={isDark ? "#fbbf24" : "#facc15"} size={24} />,
    bgColor: isDark ? "#713f12" : "#fef9c3",
    iconColor: isDark ? "#fbbf24" : "#facc15",
  },
  {
    label: "Running Batches",
    value: "",
    icon: <Activity color={isDark ? "#818cf8" : "#6366f1"} size={24} />,
    bgColor: isDark ? "#312e81" : "#e0e7ff",
    iconColor: isDark ? "#818cf8" : "#6366f1",
  },
  {
    label: "Completed Batches",
    value: "",
    icon: <CheckCircle color={isDark ? "#4ade80" : "#22c55e"} size={24} />,
    bgColor: isDark ? "#14532d" : "#dcfce7",
    iconColor: isDark ? "#4ade80" : "#22c55e",
  },
];

// const StatCard = ({ label, value, icon, bg, iconColor }) => (
//   <div
//     className={`
//     flex items-center gap-4 p-4 rounded-2xl bg-white shadow
//     transition-shadow duration-300 ease-in-out cursor-pointer
//     hover:shadow-md border-l-4 border
//   `}
//     style={{ borderColor: iconColor }}
//     onMouseEnter={(e) =>
//       (e.currentTarget.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.15)")
//     }
//     onMouseLeave={(e) =>
//       (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0, 0, 0, 0.1)")
//     }
//   >
//     <div
//       style={{
//         padding: "12px",
//         borderRadius: "9999px",
//         backgroundColor: bg,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {icon}
//     </div>
//     <div>
//       <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>{label}</p>
//       <h3
//         style={{
//           fontSize: "24px",
//           fontWeight: "bold",
//           color: "#1f2937",
//           margin: "4px 0 0 0",
//         }}
//       >
//         {value}
//       </h3>
//     </div>
//   </div>
// );

const CountDashboard = ({ summaryData }) => {
  console.log("summaryData in count dashboard--->", summaryData);
  const { isDark } = useTheme();
  const stats = getStats(isDark);
  const [dashData, setDashData] = useState(stats);

  useEffect(() => {
    const updatedStats = stats?.map((stat) => {
      let value;
      switch (stat.label) {
        case "Total Recipes":
          value = summaryData?.total_recipes || 0;
          break;
        case "Total Products":
          value = summaryData?.total_products || 0;
          break;
        case "Scheduled Batches":
          value = summaryData?.total_schedule_batches || 0;
          break;
        case "Running Batches":
          value = summaryData?.total_running_batches || 0;
          break;
        case "Completed Batches":
          value = summaryData?.total_completed_batches || 0;
          break;
        default:
          value = stat.value;
      }

      return {
        ...stat,
        value,
      };
    });
    setDashData(updatedStats);
  }, [summaryData, isDark]);

  return (
    <div className="flex gap-4 rounded-2xl">
      {dashData?.map((stat, index) => (
        <div key={index} style={{ width: "100%" }}>
          <StatCard {...stat} />
        </div>
      ))}
    </div>
  );
};

export default CountDashboard;
